import React, { useEffect, useState, useRef } from "react"
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Row,
  Space,
  notification,
  Select,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../app/store"
import styles from "./appllication.module.css"
import {
  getBuildOtherRecipeAsync,
  getCopyDetailAsync,
  getInventoryPurchAseacceptanceListAsync,
  getInventoryPurchAseacceptanceSubmitAsync,
} from "./chainSlice"
import { EditableList } from "../../compnents/list/EditableList"
import { AcceptanceColumns, CopyDetailColumns } from "./columns"
import { stringTrim } from "../../utils/StringUtils"
import { DateTimeFormat, DateTimeFormatSimple } from "../../models/datetime"
import moment from "moment"
import { sleectUserData } from "../putstorelist/putstorelistSlice"
import { User } from "../../models/user"
import { selectUserId } from "../../app/applicationSlice"

const { Option } = Select

export const AcceptanceModal = (props: {
  data: any
  visible: boolean
  category: string
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [messageApi, contextHolder] = message.useMessage()

  const [form] = Form.useForm()

  const [info, setInfo] = useState("")

  const userData: any = useSelector(sleectUserData)

  const userId = useSelector(selectUserId)

  const [pageLoading, setPageLoading] = useState(false)

  const [loading, setLoading] = useState(false)

  const [sureLoading, setSureLoading] = useState(false)

  const [page, setPage] = useState<any>({
    items: [],
    total: 0,
  })

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const required = [
    {
      title: "批号",
      dataIndex: "batchNo",
    },
    {
      title: "购进价格",
      dataIndex: "arrivalUnitPrice",
    },
    {
      title: "生产日期",
      dataIndex: "productDate",
    },
    {
      title: "有效期",
      dataIndex: "deadline",
    },
    {
      title: "到货数量",
      dataIndex: "totalQuantity",
    },
    {
      title: "验收合格数量",
      dataIndex: "qualifiedQuantity",
    },
    {
      title: "验收不合格数量",
      dataIndex: "defectiveQuantity",
    },
    {
      title: "质量状况",
      dataIndex: "qualityStatus",
    },
    {
      title: "验收结论",
      dataIndex: "acceptanceConclusion",
    },
  ]

  // 严格校验函数
  const validateRequiredFields = (data: any) => {
    const requiredFields = required
      .filter((col) => col.dataIndex)
      .map((col) => col.dataIndex)
    let isValid = true
    let fieldTitle: any = []
    data.forEach((item: any, rowIndex: number) => {
      requiredFields.forEach((field) => {
        if (!(field in item) || item[field] == null || item[field] === "") {
          isValid = false
          fieldTitle.push(
            required.find((col) => col.dataIndex === field)?.title
          )
        }
      })
    })
    fieldTitle = [...(new Set(fieldTitle) as any)].join(",")
    if (fieldTitle?.length) {
      notification.error({
        message: `请填写必填项${fieldTitle}`,
      })
    }
    return isValid
  }

  const submit = (type: number) => {
    form.validateFields().then((values) => {
      if (validateRequiredFields(page.items)) {
        type == 1 ? setLoading(true) : setSureLoading(true)
        const filterData = page.items?.filter((v: any) => {
          return Number(v.qualifiedQuantity) + Number(v.defectiveQuantity) != Number(v.totalQuantity)
        })
        if(filterData?.length) {
          notification.error({
            message: `${filterData[0]?.name}的验收合格数量和验收不合格数量之和需等于到货数量`,
          })
        } else {
          dispatch(
            getBuildOtherRecipeAsync({
              inventoryReceiptsId: props.data?.id,
              supplierId: props.data?.supplierId,
              supplierName: props.data?.supplierName,
              type: 2,
              upaccountFlag: false,
              approvedFlag: type == 1 ? false : true,
              ...values,
              arrivalDate: values?.arrivalDate
                ? moment(values?.arrivalDate).format(DateTimeFormat)
                : "",
              acceptanceDate: values?.acceptanceDate
                ? moment(values?.acceptanceDate).format(DateTimeFormat)
                : "",
              inventoryPurchaseAcceptanceBatchDTOList: page.items,
            })
          )
            .then(unwrapResult)
            .then(() => {
              type == 1 ? setLoading(false) : setSureLoading(false)
              props.onOk()
              notification.success({
                message: "操作成功",
              })
          })
          .catch(() => {
            type == 1 ? setLoading(false) : setSureLoading(false)
          })
        }
      }
    })
  }

  useEffect(() => {
    if(userId && userData) {
      form.setFieldsValue({
        acceptanceUserName: userData?.filter((v: any) => v.id == userId)?.[0]?.name
      })
    }
  }, [userId, userData, props?.visible])

  useEffect(() => {
    if (props?.visible) {
      setPageLoading(true)
      dispatch(getInventoryPurchAseacceptanceListAsync(props.data?.id))
        .then(unwrapResult)
        .then((res: any) => {
          const data = {
            total: res?.length,
            items: res?.map((v: any) => {
              return {
                ...v,
                arrivalUnitPrice: v.unitPrice,
                totalQuantity: v.totalQuantity >= 0 ? v.totalQuantity : v.count,
                qualifiedQuantity:
                  v.qualifiedQuantity >= 0 ? v.qualifiedQuantity : v.count,
                defectiveQuantity:
                  v.defectiveQuantity >= 0 ? v.defectiveQuantity : 0,
                qualityStatus: v.qualityStatus ? v.qualityStatus : "产品完好无损",
                acceptanceConclusion: v.acceptanceConclusion ? v.acceptanceConclusion : "验收合格",
              }
            }),
          }
          setPage(data)
          setPageLoading(false)
        })
    } else {
      setPage([])
      form.resetFields()
    }
  }, [props?.visible])

  return (
    <>
      {contextHolder}
      <Modal
        title="生成验收单"
        width={1400}
        visible={props?.visible}
        className={styles.copyTBDModal}
        destroyOnClose
        maskClosable={false}
        onCancel={() => {
          props?.onCancel()
        }}
        footer={null}
        centered
      >
        <div>
          <Form
            form={form}
            name="control-hooks"
            autoComplete="off"
            colon={false}
            labelCol={{ span: 7 }}
            initialValues={{
              arrivalDate: moment(),
              acceptanceDate: moment(),
            }}
            //   onFinish={(fs) => {

            //   }}
          >
            <Row gutter={20}>
              <Col span={6}>
                <Form.Item
                  name="arrivalOrderNumber"
                  label="到货单号"
                  getValueFromEvent={stringTrim}
                  rules={[{ required: true, message: "到货单号不能为空" }]}
                >
                  <Input placeholder="" allowClear />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="arrivalDate"
                  label="到货日期"
                  rules={[{ required: true, message: "到货日期不能为空" }]}
                >
                  <DatePicker
                    format={DateTimeFormatSimple}
                    allowClear
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="acceptanceUserName"
                  label="验收人"
                  rules={[{ required: true, message: "验收人不能为空" }]}
                >
                  <Select showSearch placeholder="" allowClear>
                    {userData.map((v: User) => {
                      return (
                        <Option value={v.name} key={v.id}>
                          {v.name}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="acceptanceDate"
                  label="验收日期"
                  rules={[{ required: true, message: "验收日期不能为空" }]}
                >
                  <DatePicker
                    format={DateTimeFormatSimple}
                    allowClear
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="remark"
                  label="备注"
                  getValueFromEvent={stringTrim}
                >
                  <Input placeholder="" allowClear onChange={form.submit} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <EditableList
            style={{ maxHeight: "450px", overflow: "auto", marginTop: "15px" }}
            scroll={{ x: "30rem", y: "40rem" }}
            page={{
              items: page.items,
              current: params.current,
              size: params.size,
              total: page.total,
            }}
            loading={pageLoading}
            pagination={false}
            rowKey={(m: any) => m.id}
            columns={AcceptanceColumns(
              params.size * (params.current - 1),
              (text, t) => {
                if (text == "edit") {
                  setPage({
                    ...page,
                    items: page.items?.map((item: any) => {
                      if (item.id == t.id) {
                        return t
                      } else {
                        return item
                      }
                    }),
                  })
                }
              }
            )}
            sticky
          />
          <Row justify="end" style={{ marginTop: "20px" }}>
            <Space>
              <Button onClick={props.onCancel}>取消</Button>
              <Button type="primary" onClick={() => submit(1)} loading={loading}>
                确认
              </Button>
              <Button
                loading={sureLoading}
                onClick={() => submit(2)}
                style={{ backgroundColor: "#FFA037", color: "#fff", border: 'none' }}
              >
                确认并完成审核
              </Button>
            </Space>
          </Row>
        </div>
      </Modal>
    </>
  )
}
